import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Shared';
import { OnboardingWizard } from './components/OnboardingWizard';
import { Dashboard } from './pages/Dashboard';
import { Timeline } from './pages/Timeline';
import {
  EntityPage,
  CompliancePage,
  TransactionsPage,
  NoticesPage,
  DocumentsPage,
  ContractsPage,
  LearnIndexPage,
  LearnTopicPage,
} from './pages/AllPages';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Onboarding lives outside the app shell */}
        <Route path="/onboarding" element={<OnboardingWizard />} />

        {/* Main app shell */}
        <Route
          path="/*"
          element={
            <div className="app">
              <Sidebar />
              <main className="main">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/timeline" element={<Timeline />} />
                  <Route path="/entity" element={<EntityPage />} />
                  <Route path="/compliance/:jurisdiction" element={<CompliancePage />} />
                  <Route path="/transactions" element={<TransactionsPage />} />
                  <Route path="/notices" element={<NoticesPage />} />
                  <Route path="/documents" element={<DocumentsPage />} />
                  <Route path="/contracts" element={<ContractsPage />} />
                  <Route path="/learn" element={<LearnIndexPage />} />
                  <Route path="/learn/:topic_key" element={<LearnTopicPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
